// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2LoaB","signatureBlock":"Footer_signatureBlock__2WU98","signature":"Footer_signature__1m0LK"};